import CTLBooleanCell from "application/components/CTLBooleanCell";
import CTLCategoryServiceCell from "application/components/CTLCategoryServiceCell";
import CTLNotificationBooleanCell from "application/components/CTLNotificationBooleanCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { nmsMenus } from "globals/configuration/nms";
import formControl from "globals/form-control";

const Attributes = {
  formSize: "md",
  columns: 3,
  enableAddButton: true,
  modes: nmsMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),

  messages: {
    success: "Updated successfully",
    error: "Unable to update data",
  },
  messages: {
    success: "Updated successfully",
    error: "Unable to update data",
  },
  settingsMode: false,
};

const operationURLS = {
  list: "categoryService/list",
  create: "categoryService/create",
  update: "categoryService/update",
  delete: "categoryService/delete/",
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Service Code",
      accessor: "serviceCode",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      controlType: "select",
      groupHeading: "Category Service",
      options: {
        keyField: "serviceCode",
        keyDescription: "serviceName",
        values: [],
        url: "categoryService/dropdownServiceCode/list",
      },
      width: 6,
    },

    {
      Header: "Catgeory Code",
      accessor: "categoryCode",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      Cell: ({ value }) => <DefaultCell value={value} />,
      groupHeading: "Category Service",
      options: {
        keyField: "categoryCode",
        keyDescription: "categoryName",
        values: [],
        url: "categoryService/dropdownCategoryCode/list",
      },
      width: 6,
    },
    {
      Header: "Severity",
      accessor: "severity",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLCategoryServiceCell value={value} />,
      dataType: "string",
      controlType: "selectWithColor",
      options: {
        keyField: "severityLevel",
        keyDescription1: "severityName",
        keyDescription2: "color",
        values: [],
        url: "severity/listAll",
      },
      width: 6,
    },
    {
      Header: "Alert Description",
      accessor: "alertDescription",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      groupHeading: "Category Service",
      width: 6,
    },
    {
      Header: "Disable Notification",
      accessor: "disableNotification",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <CTLNotificationBooleanCell value={value} />,
      dataType: "boolean",
      controlType: "boolean",
      groupHeading: "Category Service",
      width: 6,
    },
    {
      Header: "Level 0 Mail Id",
      accessor: "escalationLevel0MailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 0 Sms Number",
      accessor: "escalationLevel0SmsId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 1 Duration",
      accessor: "escalationLevel1Duration",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "integer",
      width: 6,
    },
    {
      Header: "Level 1 Mail Id",
      accessor: "escalationLevel1MailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 1 Sms Number",
      accessor: "escalationLevel1SmsId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 2 Duration",
      accessor: "escalationLevel2Duration",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "integer",
      width: 6,
    },
    {
      Header: "Level 2 Mail Id",
      accessor: "escalationLevel2MailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 2 Sms Number",
      accessor: "escalationLevel2SmsId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 3 Duration",
      accessor: "escalationLevel3Duration",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "integer",
      width: 6,
    },

    {
      Header: "Level 3 Mail Id",
      accessor: "escalationLevel3MailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },

    {
      Header: "Level 3 Sms Number",
      accessor: "escalationLevel3SmsId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
